<div class="full-page w-100 px-0 h-100" [style.backgroundImage]="'url(' + ('login/login-banner.jpg' | contentAssetImage) + ')'">
  <div class="login-container h-100">
    <img class="logo" [src]="'logos/blue-rewards-logo.png' | contentAssetImage" draggable="false" />

    <div class="login-details rounded">
      <h4 class="mb-0 text-uppercase fw-bold">{{ 'login.page.title' | translate }}</h4>
      <div class="font-size-14">{{ 'login.page.description' | translate }}</div>
      <fgb-fusion-user-login class="w-100"></fgb-fusion-user-login>

      <ng-container *ngIf="errorCode$ | async as errorCode">
        <div class="text-danger text-center mt-2 fw-bold">
          {{ errorCode | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
